/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Exercise_NoteInputs */

const en_us2_offline_kind_exercise_note = /** @type {(inputs: Offline_Kind_Exercise_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinned note on an exercise`)
};

const pt_br2_offline_kind_exercise_note = /** @type {(inputs: Offline_Kind_Exercise_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota fixa de exercício`)
};

const es_419_offline_kind_exercise_note = /** @type {(inputs: Offline_Kind_Exercise_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota fijada en un ejercicio`)
};

const pt_pt2_offline_kind_exercise_note = /** @type {(inputs: Offline_Kind_Exercise_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota fixa de exercício`)
};

const fr_fr2_offline_kind_exercise_note = /** @type {(inputs: Offline_Kind_Exercise_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note épinglée sur un exercice`)
};

const de_de2_offline_kind_exercise_note = /** @type {(inputs: Offline_Kind_Exercise_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angeheftete Notiz zu einer Übung`)
};

const it_it2_offline_kind_exercise_note = /** @type {(inputs: Offline_Kind_Exercise_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota fissata su un esercizio`)
};

/**
* | output |
* | --- |
* | "Pinned note on an exercise" |
*
* @param {Offline_Kind_Exercise_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_exercise_note = /** @type {((inputs?: Offline_Kind_Exercise_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Exercise_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_exercise_note(inputs)
	if (locale === "es-419") return es_419_offline_kind_exercise_note(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_exercise_note(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_exercise_note(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_exercise_note(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_exercise_note(inputs)
	return en_us2_offline_kind_exercise_note(inputs)
});
export { offline_kind_exercise_note as "offline.kind_exercise_note" }